import { useNavigate } from 'react-router';
import { useAuth } from '../../contexts/AuthContext';
import WorkspaceSwitcher from '../WorkspaceSwitcher';
import AnnotationMap from './AnnotationMap';
import './OperatorWorkspace.css';

export default function OperatorWorkspace() {
  const { profile, signOut } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="op-root">
      <header className="op-bar">
        <div className="op-bar-brand">
          <div className="op-bar-brand-icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="9" cy="9" r="3" fill="rgba(255,255,255,0.95)" />
              <circle cx="9" cy="9" r="7" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5" />
              <path d="M9 2V1M9 17V16M2 9H1M17 9H16" stroke="rgba(255,255,255,0.5)" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </div>
          <span className="op-bar-title">پنل اپراتور</span>
          <span className="op-bar-divider" aria-hidden="true" />
          <span className="op-bar-subtitle">سامانه تحلیل پوشش فیبر</span>
        </div>

        <div className="op-bar-actions">
          <div className="op-bar-user">
            <span className="op-bar-user-avatar" aria-hidden="true">
              {(profile?.full_name || 'ا').charAt(0)}
            </span>
            <span className="op-bar-user-name">
              {profile?.full_name || 'اپراتور'}
            </span>
          </div>
          <button type="button" onClick={() => navigate('/design')} className="op-bar-btn">طراحی شبکه</button>
          <WorkspaceSwitcher current="operator" />
          <button className="op-logout-btn" onClick={onLogout} type="button">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M5.25 2.333H2.917A.583.583 0 0 0 2.333 2.917v8.166c0 .323.261.584.584.584H5.25" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9.333 10.5 11.667 7l-2.334-3.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M5.833 7h5.834" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
            </svg>
            خروج
          </button>
        </div>
      </header>

      <div className="op-map">
        <AnnotationMap />
      </div>
    </div>
  );
}
